export default {
  SET_GROUP_DATA(state, groupData) {
    state.groups = groupData;
  },
  SET_GROUP_RECORDS(state, totalGroups) {
    state.totalGroups = totalGroups;
  },
  SET_CURRENT_PAGE(state, data) {
    state.groups.currentPage = data;
  },
};
